var map = {
	"./flags/en.svg": 999,
	"./flags/es.svg": 1000,
	"./flags/fr.svg": 1001,
	"./flags/it.svg": 1002,
	"./flags/nl.svg": 1003,
	"./flags/pt.svg": 1004,
	"./icons/icon-arrow-down.svg": 156,
	"./icons/icon-arrow-up.svg": 157,
	"./icons/icon-beach--green.svg": 1005,
	"./icons/icon-beach--red.svg": 1006,
	"./icons/icon-beach.svg": 1007,
	"./icons/icon-break.svg": 1008,
	"./icons/icon-chevron-circle-left--white.svg": 1009,
	"./icons/icon-chevron-circle-left.svg": 1010,
	"./icons/icon-chevron-circle-right--white.svg": 1011,
	"./icons/icon-chevron-circle-right.svg": 1012,
	"./icons/icon-chevron-left--white.svg": 1013,
	"./icons/icon-info--circle.svg": 1014,
	"./icons/icon-legend-buoys.svg": 1015,
	"./icons/icon-legend-star.svg": 1016,
	"./icons/icon-legend-swell-arrow.svg": 1017,
	"./icons/icon-legend-swell.svg": 1018,
	"./icons/icon-legend-wind.svg": 1019,
	"./icons/icon-loader.svg": 1020,
	"./icons/icon-point--green.svg": 1021,
	"./icons/icon-point--red.svg": 1022,
	"./icons/icon-point.svg": 1023,
	"./icons/icon-reef--green.svg": 1024,
	"./icons/icon-reef--red.svg": 1025,
	"./icons/icon-reef.svg": 1026,
	"./icons/icon-river--green.svg": 1027,
	"./icons/icon-river--red.svg": 1028,
	"./icons/icon-river.svg": 1029,
	"./icons/icon-sandbar--green.svg": 1030,
	"./icons/icon-sandbar--red.svg": 1031,
	"./icons/icon-sandbar.svg": 1032,
	"./icons/icon-thumbs-down-solid.svg": 1033,
	"./icons/icon-thumbs-up-solid.svg": 1034,
	"./icons/icon-tidal-range--blue.svg": 1035,
	"./icons/icon-tide-clock--color.svg": 1036,
	"./icons/icon-tide-needle.svg": 1037,
	"./icons/icon-tide-star.svg": 1038,
	"./logos/apple-logo--black.svg": 94,
	"./logos/apple-logo--white.svg": 1039,
	"./logos/google-g-logo.svg": 95,
	"./logos/outside-logo--black.svg": 1040,
	"./logos/outside-logo--white.svg": 1041,
	"./logos/surf-forecast__logo--black.svg": 1042,
	"./logos/surf-forecast__logo--clear.svg": 1043,
	"./logos/surf-forecast__logo--white.svg": 1044,
	"./logos/surf-forecast__logo.svg": 1045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 998;